import { gql } from 'apollo-angular';

export const ROTATION_IMAGE_ARRAY_INFO_FRAGMENT = gql`
  fragment RotationImageArrayInfo on RotationImageArray {
    id
    name
    imagesIds
  }
`;
